"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _iterables = require("rich-text-lib/utils/iterables");

var _ToolbarButton = _interopRequireDefault(require("rich-text-lib/components/toolbar/ToolbarButton"));

var _formatting = require("tinymce-plugins/utils/formatting");

var _utils = require("tinymce-plugins/hsformatting/utils");

var ControlButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ControlButton, _Component);

  function ControlButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ControlButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ControlButton).call(this, props));

    _this.onClick = function () {
      _this.props.onClick(!_this.state.isActive);
    };

    _this.state = {
      isActive: false,
      isDisabled: false
    };
    _this.handleFormatChanged = _this.handleFormatChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleNodeChange = _this.handleNodeChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ControlButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          editor = _this$props.editor,
          formatName = _this$props.formatName,
          getInitialActive = _this$props.getInitialActive,
          nodesAffectedByInheritedStyles = _this$props.nodesAffectedByInheritedStyles;
      var initialActive = getInitialActive();

      if (this.state.isActive !== initialActive) {
        this.setState({
          isActive: initialActive
        });
      }

      if (nodesAffectedByInheritedStyles.length > 0) {
        editor.on('NodeChange', this.handleNodeChange);
      } else {
        editor.on("FormatChanged:" + formatName, this.handleFormatChanged);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          editor = _this$props2.editor,
          formatName = _this$props2.formatName;
      editor.off("FormatChanged:" + formatName, this.handleFormatChanged);
      editor.off('NodeChange', this.handleNodeChange);
    }
  }, {
    key: "handleNodeChange",
    value: function handleNodeChange(evt) {
      var isActive = (0, _utils.shouldApplyOverrideFormat)(this.props.editor, this.props.nodesAffectedByInheritedStyles) ? _formatting.nodeChangeHandlers[this.props.formatName](evt) : this.props.editor.formatter.match(this.props.formatName);

      if (isActive !== this.state.isActive) {
        this.setState({
          isActive: isActive
        });
      }
    }
  }, {
    key: "handleFormatChanged",
    value: function handleFormatChanged(evt) {
      var eventState = (0, _iterables.pick)(['isActive', 'isDisabled'], evt);
      this.setState((0, _extends2.default)({}, eventState));
    }
  }, {
    key: "render",
    value: function render() {
      var buttonProps = (0, _iterables.omit)([].concat((0, _toConsumableArray2.default)(Object.keys(ControlButton.propTypes)), ['onClick']), this.props);
      return _react.default.createElement(_ToolbarButton.default, (0, _extends2.default)({
        selected: !!this.state.isActive,
        disabled: !!this.state.isDisabled,
        onClick: this.onClick,
        name: this.props.formatName
      }, buttonProps));
    }
  }]);
  return ControlButton;
}(_react.Component);

exports.default = ControlButton;
ControlButton.propTypes = {
  editor: _react.PropTypes.object.isRequired,
  formatName: _react.PropTypes.string.isRequired,
  getInitialActive: _react.PropTypes.func,
  nodesAffectedByInheritedStyles: _react.PropTypes.array,
  onClick: _react.PropTypes.func.isRequired
};
ControlButton.defaultProps = {
  getInitialActive: function getInitialActive() {
    return false;
  },
  nodesAffectedByInheritedStyles: []
};
module.exports = exports.default;